import { Fork, Invoke } from '@swf/components/StarsWizard/Flow';

import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';
import RMFSummaryScreen from '../../components/RMFSummaryScreen/RMFSummaryScreen';
import RMFVerification from '../../components/RMFVerification/RMFVerification';
import useRMFBaseSteps from '../useRMFBaseSteps';

import { Guard } from './../useRmfGuards';
import { Service } from './../useRmfServices';

const useRmfUKBaseSteps = () => {
  const { forkRmfExit } = useRMFBaseSteps();
  const forkVerification = new Fork(
    Guard.RecheckUserFlags,
    [RMFVerification, forkRmfExit],
    [forkRmfExit]
  );

  const invokeRetryEnableRealMoneyFlag = new Invoke(
    Service.RmfRetryInvokeRealMoneyOk,
    forkVerification
  );

  const invokeRetryDataSave: Invoke = new Invoke(
    Service.RmfRetryUserDataSave,
    invokeRetryEnableRealMoneyFlag
  );

  const forkSummaryScreen: Fork = new Fork(
    Guard.IsRetryScreenEnabled,
    [RMFSummaryScreen, invokeRetryDataSave],
    [RMFVerification]
  );

  const invokeDepositLimitSave: Invoke = new Invoke(
    Service.RmfDepositLimitSave,
    RMFPlayerFundsProtection,
    RMFDepositLimit
  );
  const forkRetryScreen = new Fork(Guard.CheckUserFlags, [forkSummaryScreen], [forkRmfExit]);

  const invokeEnableRealMoneyFlag = new Invoke(Service.RmfEnableRealMoneyFlag, forkRetryScreen);
  const invokeUserDataSave = new Invoke(Service.RmfUserDataSave, invokeEnableRealMoneyFlag);

  return {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeRetryDataSave,
    forkSummaryScreen,
    invokeDepositLimitSave,
    forkRetryScreen,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave
  };
};

export default useRmfUKBaseSteps;
